module.exports = __webpack_public_path__ + "img/galeria_salas_de_aula (1).18528ec4.jpeg";